var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/socialMedia/index.ts
var socialMedia_exports = {};
__export(socialMedia_exports, {
  createAccountUrl: () => createAccountUrl,
  createShareUrl: () => createShareUrl
});

// src/socialMedia/createAccountUrl.ts
function createAccountUrl(target, account = "") {
  switch (target) {
    case "facebook_group":
      return `https://www.facebook.com/groups/${account}`;
    case "facebook_messenger":
      return `https://www.messenger.com/t/${account}`;
    case "facebook_page":
      return `https://www.facebook.com/${account}`;
    case "google_plus":
      return `https://plus.google.com/${account}`;
    case "instagram":
      return `https://www.instagram.com/${account}`;
    case "spotify":
      return `https://open.spotify.com/${account}`;
    case "twitter":
      return `https://twitter.com/${account}`;
    case "youtube":
      return `https://www.youtube.com/channel/${account}`;
    default:
      return "#";
  }
}

// src/socialMedia/createShareUrl.ts
function createShareUrl(target, body, url = "") {
  var _a;
  if (!url) {
    url = (_a = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : _a.href;
  }
  const _url = new URL(url);
  const foundOnBRString = "via BR24";
  const emailFoundOnBRString = "Via BR24";
  const twitterFoundOnBRString = "via @BR24";
  let origin = "";
  let utmSource = "unknown";
  const params = {};
  switch (target) {
    case "facebook":
      utmSource = "Facebook";
      origin = "https://www.facebook.com/sharer.php";
      params.u = _url.href;
      break;
    case "twitter":
      utmSource = "Twitter";
      origin = "https://twitter.com/intent/tweet";
      params.text = body ? `${body} | ${twitterFoundOnBRString}

${_url}` : _url.href;
      break;
    case "email":
      utmSource = "E-Mail";
      origin = "mailto:";
      params.subject = body ? `${emailFoundOnBRString}: ${body} ` : emailFoundOnBRString;
      params.body = body ? `${body} | ${foundOnBRString}

${_url}` : _url.href;
      break;
    case "whatsapp":
      utmSource = "WhatsApp";
      origin = "https://api.whatsapp.com/send";
      params.text = body ? `${body} | ${foundOnBRString} | ${_url}` : `${emailFoundOnBRString} | ${_url}`;
      break;
    case "url":
      utmSource = "Link";
      origin = _url.href;
      break;
    default:
      throw new Error("Not platform specified.");
  }
  const shareUrl = new URL(origin);
  Object.entries({
    ...params,
    UTM_Name: "Web-Share",
    UTM_Medium: "Link",
    UTM_Source: utmSource
  }).forEach(([key, value]) => {
    shareUrl.searchParams.set(key, value);
  });
  return shareUrl.href;
}

// src/image/index.ts
var image_exports = {};
__export(image_exports, {
  SIZE_11_L: () => SIZE_11_L,
  SIZE_11_M: () => SIZE_11_M,
  SIZE_11_S: () => SIZE_11_S,
  SIZE_11_XL: () => SIZE_11_XL,
  SIZE_11_XS: () => SIZE_11_XS,
  SIZE_11_XXL: () => SIZE_11_XXL,
  SIZE_11_XXXL: () => SIZE_11_XXXL,
  SIZE_169_L: () => SIZE_169_L,
  SIZE_169_M: () => SIZE_169_M,
  SIZE_169_S: () => SIZE_169_S,
  SIZE_169_XL: () => SIZE_169_XL,
  SIZE_169_XS: () => SIZE_169_XS,
  SIZE_169_XXL: () => SIZE_169_XXL,
  SIZE_169_XXXL: () => SIZE_169_XXXL,
  resize: () => resize
});

// src/image/config.ts
var PRESETS = {
  square: {
    width: 1600,
    height: 1600
  },
  landscape: {
    width: 1600,
    height: 900
  }
};
var SCALE = {
  xs: 1 / 9,
  s: 1 / 5,
  m: 1 / 4,
  l: 1 / 3,
  xl: 1 / 2,
  xxl: 1,
  xxxl: 1.3
};
var SIZES = {
  square: {
    xs: {
      width: PRESETS.square.width * SCALE["xs"],
      height: PRESETS.square.height * SCALE["xs"]
    },
    s: {
      width: PRESETS.square.width * SCALE["s"],
      height: PRESETS.square.height * SCALE["s"]
    },
    m: {
      width: PRESETS.square.width * SCALE["m"],
      height: PRESETS.square.height * SCALE["m"]
    },
    l: {
      width: PRESETS.square.width * SCALE["l"],
      height: PRESETS.square.height * SCALE["l"]
    },
    xl: {
      width: PRESETS.square.width * SCALE["xl"],
      height: PRESETS.square.height * SCALE["xl"]
    },
    xxl: {
      width: PRESETS.square.width * SCALE["xxl"],
      height: PRESETS.square.height * SCALE["xxl"]
    },
    xxxl: {
      width: PRESETS.square.width * SCALE["xxxl"],
      height: PRESETS.square.height * SCALE["xxxl"]
    }
  },
  landscape: {
    xs: {
      width: PRESETS.landscape.width * SCALE["xs"],
      height: PRESETS.landscape.height * SCALE["xs"]
    },
    s: {
      width: PRESETS.landscape.width * SCALE["s"],
      height: PRESETS.landscape.height * SCALE["s"]
    },
    m: {
      width: PRESETS.landscape.width * SCALE["m"],
      height: PRESETS.landscape.height * SCALE["m"]
    },
    l: {
      width: PRESETS.landscape.width * SCALE["l"],
      height: PRESETS.landscape.height * SCALE["l"]
    },
    xl: {
      width: PRESETS.landscape.width * SCALE["xl"],
      height: PRESETS.landscape.height * SCALE["xl"]
    },
    xxl: {
      width: PRESETS.landscape.width * SCALE["xxl"],
      height: PRESETS.landscape.height * SCALE["xxl"]
    },
    xxxl: {
      width: PRESETS.landscape.width * SCALE["xxxl"],
      height: PRESETS.landscape.height * SCALE["xxxl"]
    }
  }
};
var SIZE_169_XS = {
  width: PRESETS.landscape.width / 9,
  height: PRESETS.landscape.height / 9
};
var SIZE_169_S = {
  width: PRESETS.landscape.width / 5,
  height: PRESETS.landscape.height / 5
};
var SIZE_169_M = {
  width: PRESETS.landscape.width / 4,
  height: PRESETS.landscape.height / 4
};
var SIZE_169_L = {
  width: PRESETS.landscape.width / 3,
  height: PRESETS.landscape.height / 3
};
var SIZE_169_XL = {
  width: PRESETS.landscape.width / 2,
  height: PRESETS.landscape.height / 2
};
var SIZE_169_XXL = { width: PRESETS.landscape.width, height: PRESETS.landscape.height };
var SIZE_169_XXXL = {
  width: PRESETS.landscape.width * 1.3,
  height: PRESETS.landscape.height * 1.3
};
var SIZE_11_XS = { width: PRESETS.square.width / 9, height: PRESETS.square.height / 9 };
var SIZE_11_S = { width: PRESETS.square.width / 5, height: PRESETS.square.height / 5 };
var SIZE_11_M = { width: PRESETS.square.width / 4, height: PRESETS.square.height / 4 };
var SIZE_11_L = { width: PRESETS.square.width / 3, height: PRESETS.square.height / 3 };
var SIZE_11_XL = { width: PRESETS.square.width / 2, height: PRESETS.square.height / 2 };
var SIZE_11_XXL = { width: PRESETS.square.width, height: PRESETS.square.height };
var SIZE_11_XXXL = {
  width: PRESETS.square.width * 1.3,
  height: PRESETS.square.height * 1.3
};

// src/image/resize.ts
function resize(url, options, size = "xxl") {
  let width;
  let height;
  if (typeof options === "object") {
    width = options.width;
    height = options.height;
  } else {
    if (size === void 0) {
      throw new Error("size must be specified");
    }
    width = PRESETS[options].width * SCALE[size];
    height = PRESETS[options].height * SCALE[size];
  }
  const _url = new URL(url);
  if (typeof width === "number") {
    _url.searchParams.set("w", width.toString());
  }
  if (typeof height === "number") {
    _url.searchParams.set("h", height.toString());
  }
  return _url.href;
}

// src/cache/index.ts
var cache_exports = {};
__export(cache_exports, {
  CacheTagKind: () => CacheTagKind,
  createCacheTag: () => createCacheTag,
  finalizeCacheTags: () => finalizeCacheTags,
  getCacheTagKind: () => getCacheTagKind,
  isCacheTag: () => isCacheTag,
  isValidCacheTag: () => isValidCacheTag,
  prioritizeCacheTags: () => prioritizeCacheTags
});
var CACHE_TAG_SEPARATOR = ".";
var CACHE_TAG_LIST_SEPARATOR = ",";
var MAX_CACHE_TAGS = 128;
var CacheTagKind = /* @__PURE__ */ ((CacheTagKind2) => {
  CacheTagKind2["Article"] = "a";
  CacheTagKind2["Author"] = "au";
  CacheTagKind2["Board"] = "b";
  CacheTagKind2["BoardTeaser"] = "bt";
  CacheTagKind2["BreakingNews"] = "bn";
  CacheTagKind2["Category"] = "c";
  CacheTagKind2["FilterArticles"] = "fa";
  CacheTagKind2["Global"] = "br24";
  CacheTagKind2["HeadLines"] = "hl";
  CacheTagKind2["Navigation"] = "n";
  CacheTagKind2["Search"] = "s";
  CacheTagKind2["ShortNews"] = "sn";
  CacheTagKind2["Tag"] = "t";
  CacheTagKind2["Radio"] = "r";
  return CacheTagKind2;
})(CacheTagKind || {});
var availableCacheTagKinds = [
  "a" /* Article */,
  "au" /* Author */,
  "b" /* Board */,
  "bt" /* BoardTeaser */,
  "c" /* Category */,
  "fa" /* FilterArticles */,
  "hl" /* HeadLines */,
  "n" /* Navigation */,
  "s" /* Search */,
  "sn" /* ShortNews */,
  "t" /* Tag */
];
function createCacheTag(kind, value) {
  const haystack = [kind];
  if (value) {
    haystack.push(value);
  }
  return haystack.join(CACHE_TAG_SEPARATOR);
}
function getCacheTagKind(value) {
  if (typeof value === "string" && !value.includes(CACHE_TAG_SEPARATOR)) {
    const index = availableCacheTagKinds.indexOf(value);
    if (index === -1) {
      return null;
    }
    return availableCacheTagKinds[index];
  }
  if (typeof value === "string" && value.includes(CACHE_TAG_SEPARATOR)) {
    const [maybeCacheTagKind] = value.split(CACHE_TAG_SEPARATOR);
    return getCacheTagKind(maybeCacheTagKind);
  }
  return null;
}
function isCacheTag(value) {
  return getCacheTagKind(value) !== null;
}
function prioritizeCacheTags(prioritization, tags) {
  return [...tags].sort((left, right) => {
    const leftCacheTag = getCacheTagKind(left);
    const maybeLeftPower = leftCacheTag ? prioritization.indexOf(leftCacheTag) : -1;
    const leftPower = maybeLeftPower === -1 ? null : maybeLeftPower;
    const rightCacheTag = getCacheTagKind(right);
    const maybeRightPower = rightCacheTag ? prioritization.indexOf(rightCacheTag) : -1;
    const rightPower = maybeRightPower === -1 ? null : maybeRightPower;
    if (leftPower === null || rightPower === null) {
      return left < right ? -1 : 1;
    }
    return leftPower < rightPower ? -1 : 1;
  });
}
function isValidCacheTag(value) {
  if (value.trim().length === 0) {
    return false;
  }
  if (Buffer.from(value).byteLength > 128) {
    return false;
  }
  return !/(\*|"|\(|\)|,|:|;|<|=|>|\?|@|\\|\[|\]|\{|\})/g.test(value);
}
function finalizeCacheTags(tags, prioritization) {
  let result = Array.from(new Set(tags.filter(isValidCacheTag)));
  if (result.length > MAX_CACHE_TAGS) {
    result = result.slice(0, MAX_CACHE_TAGS);
  }
  if (prioritization) {
    result = prioritizeCacheTags(prioritization, result);
  }
  return result.join(CACHE_TAG_LIST_SEPARATOR);
}

// src/url/index.ts
var url_exports = {};
__export(url_exports, {
  getInfo: () => getInfo,
  getSiteName: () => getSiteName,
  hostIsBlacklisted: () => hostIsBlacklisted,
  hostIsWhitelisted: () => hostIsWhitelisted
});
import { LINKS_DOMAINS_WHITELIST } from "@sep/br24-constants";
import minimatch from "minimatch";
var hostIsWhitelisted = (host, whitelist = [...LINKS_DOMAINS_WHITELIST]) => whitelist.findIndex((pattern) => minimatch(host, pattern)) !== -1;
var hostIsBlacklisted = (host, blacklist) => blacklist.findIndex((pattern) => minimatch(host, pattern)) !== -1;
var BR_HOSTNAME = "br.de";
var BR24 = "BR24";
var BR24_OTHER_ENV = "BR24_OTHER_ENV";
var BR24_PATH_SEGMENT = "/nachrichten";
var MEDIATHEK_PATH_SEGMENT = "/mediathek";
var PULS_PATH_SEGMENT = "/puls";
var PULS = "PULS";
var BAYERN3 = "BAYERN 3";
var BAYERN3_HOSTNAME = "bayern3.de";
var BRKLASSIK = "BR-KLASSIK";
var MEDIATHEK = "BR Mediathek";
var BRKLASSIK_HOSTNAME = "br-klassik.de";
var OTHER = "OTHER";
var SPORTSCHAU = "sportschau.de";
var TAGESSCHAU = "tagesschau.de";
var LOCALHOST = "localhost";
var BASE_URLS = {
  [`BR24_SHORT`]: "br24.de",
  [`BR24_DEV`]: "br-dev.de",
  [`BR24_STAGING`]: "br-staging.de",
  [BR24]: `www.${BR_HOSTNAME}${BR24_PATH_SEGMENT}`,
  [PULS]: `www.${BR_HOSTNAME}${PULS_PATH_SEGMENT}`,
  [MEDIATHEK]: `www.${BR_HOSTNAME}${MEDIATHEK_PATH_SEGMENT}`,
  [BAYERN3]: null,
  [BRKLASSIK]: null,
  [SPORTSCHAU]: null,
  [TAGESSCHAU]: null,
  [OTHER]: null,
  [BR24_OTHER_ENV]: null
};
function getSiteName({ hostname, href }, branch) {
  if (hostname.endsWith(BASE_URLS[`BR24_SHORT`]) || hostname.endsWith(BASE_URLS[`BR24_DEV`]) || hostname.endsWith(BASE_URLS[`BR24_STAGING`])) {
    if (href.indexOf(`${BASE_URLS[`${BR24}_SHORT`]}${BR24_PATH_SEGMENT}`) > "http://".length) {
      return branch !== "master" ? BR24_OTHER_ENV : BR24;
    }
    return BR24;
  }
  if (hostname.startsWith(LOCALHOST)) {
    if (href.indexOf(BR24_PATH_SEGMENT) > "http://".length) {
      return BR24;
    }
  }
  if (hostname.endsWith("br.de")) {
    if (href.indexOf(`br.de${BR24_PATH_SEGMENT}`) > "http://".length) {
      return branch !== "master" ? BR24_OTHER_ENV : BR24;
    }
    if (href.indexOf(`br.de${MEDIATHEK_PATH_SEGMENT}`) > "http://".length) {
      return MEDIATHEK;
    }
    if (href.indexOf(`br.de${PULS_PATH_SEGMENT}`) > "http://".length) {
      return PULS;
    }
  }
  if (hostname.endsWith(BAYERN3_HOSTNAME)) {
    return BAYERN3;
  }
  if (hostname.endsWith(TAGESSCHAU)) {
    return TAGESSCHAU;
  }
  if (hostname.endsWith(BRKLASSIK_HOSTNAME)) {
    return BRKLASSIK;
  }
  if (hostname.endsWith(SPORTSCHAU)) {
    return SPORTSCHAU;
  }
  return OTHER;
}
function getInfo(url, branch) {
  const _url = typeof url === "string" ? new URL(url) : url;
  const { hostname } = _url;
  let isWhitelisted = hostIsWhitelisted(hostname);
  const site = getSiteName(_url, branch);
  let meta = null;
  if (site === BR24) {
    meta = _url.href.split(",").pop();
    if (meta === url) {
      meta = null;
    }
    isWhitelisted = true;
  } else if (site === MEDIATHEK) {
    const splitUrl = _url.href.split("-av:");
    if (splitUrl && splitUrl.length == 2) {
      meta = "av:" + splitUrl[1];
    }
    isWhitelisted = true;
  }
  const baseUrl = BASE_URLS[site] || hostname;
  return {
    site: site !== OTHER ? site : hostname.replace(/^www\./i, ""),
    isWhitelisted,
    hostname,
    baseUrl,
    meta
  };
}

// src/string/index.ts
var string_exports = {};
__export(string_exports, {
  stripTags: () => stripTags,
  truncate: () => truncate
});

// src/string/stripTags.ts
var stripTags = (value) => value.replace(/(<([^>]+)>)/gi, "");

// src/string/truncate.ts
function truncate(value, maxLength = 250, suffix = "...") {
  const strippedValue = stripTags(value);
  const newMaxLength = maxLength - suffix.length;
  return `${strippedValue.substring(0, newMaxLength)}${strippedValue.length > newMaxLength ? suffix : ""}`;
}

// src/color/index.ts
var color_exports = {};
__export(color_exports, {
  byCategory: () => byCategory
});

// src/color/byCategory.ts
import { COLOR_BOARD_SECTION_4, COLOR_CATEGORY_BY_CATEGORY_ID } from "@sep/br24-constants";
var byCategory = ({ color, categoryByCategoryId, categoryId }) => COLOR_CATEGORY_BY_CATEGORY_ID[(categoryByCategoryId == null ? void 0 : categoryByCategoryId.rowId) ?? categoryId] ?? color ?? COLOR_BOARD_SECTION_4;
export {
  cache_exports as cache,
  color_exports as color,
  image_exports as image,
  socialMedia_exports as socialMedia,
  string_exports as string,
  url_exports as url
};
//# sourceMappingURL=index.js.map